export default {
  "name": "NCBillHead",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCBillHead",
  "label": "标题",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "title": {
        "title": "标题",
        "description": "标题",
        "type": "string"
      },
      "billCode": {
        "title": "单号",
        "description": "单号",
        "type": "string"
      },
      "initShowBackBtn": {
        "title": "显示后退按钮",
        "description": "显示后退按钮",
        "type": "boolean"
      },
      "showPagination": {
        "title": "显示分页",
        "description": "显示分页",
        "type": "boolean"
      },
      "showRefresh": {
        "title": "显示刷新",
        "description": "显示刷新",
        "type": "boolean"
      },
      "urlPkname": {
        "title": "url主键名称",
        "description": "url主键名称",
        "type": "string"
      },
      "leftArea": {
        "title": "缓存code",
        "description": "缓存code",
        "type": "node"
      },
      "rightArea": {
        "title": "url主键名称",
        "description": "url主键名称",
        "type": "node"
      },
      "visible": {
        "title": "是否可见",
        "description": "是否可见",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": [
    "leftArea",
    "rightArea"
  ]
}